import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

/** Módulo escondido no build de produção até a liberação por plano. */
export const whatsappModuleGuard: CanActivateFn = () => {
    const router = inject(Router);
    return environment.whatsappModuleEnabled ? true : router.parseUrl('/v2/painel');
};
